import { render, staticRenderFns } from "./BigcardAdForm.vue?vue&type=template&id=7ed8163c&"
import script from "./BigcardAdForm.vue?vue&type=script&lang=js&"
export * from "./BigcardAdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports